<template>
    <v-tab-item>
        <memo-form v-model="memo" v-on="{ post }" />
    </v-tab-item>
</template>

<script>
import api from "@/api";
import { initMemo } from "@/assets/variables";

import MemoForm from "../memo/memo-form.vue";

export default {
    components: {
        MemoForm,
    },
    props: {
        application: { type: Object, default: () => ({}) },
    },
    data: () => ({
        memo: initMemo(),

        loading: false,
    }),
    computed: {
        params() {
            return {
                _application: this.application?._id,
                _recruitment: this.application?._recruitment,
            };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        application() {
            this.init();
        },
    },
    methods: {
        async init() {
            this.loading = true;
            try {
                let { params } = this;
                this.memo = (await api.v1.company.recruitments.applications.memo.get(params))?.memo || initMemo();
            } finally {
                this.loading = false;
            }
        },
        async post() {
            this.loading = true;
            try {
                this.memo = (await api.v1.company.recruitments.applications.memo.put({ ...this.memo, ...this.params }))?.memo;
                alert("저장되었습니다");
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style>
</style>